// Exports package.json to work around "with" and "assert" for backwards compatability.
module.exports = require('./package.json').version
